import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { SubSection, Title } from './components';
import { useExpandCollapse } from './hooks';
import { ItemsWrapper, Wrapper } from './styled';
const SectionComponent = memo(forwardRef(function SectionComponent({ children, id, className, height, inner, horizontal, dataTestId, title, tooltip, tag, filters, actions, expanded, onToggle, togglePosition, toggleIcon, }, ref) {
    const { getCollapseProps } = useExpandCollapse(expanded);
    const hasTitle = !!(title || filters || actions);
    return (_jsxs(Wrapper, { id: id, className: className, height: height, inner: inner, ref: ref, "data-testid": dataTestId, children: [hasTitle && (_jsx(Title, { title: title, tooltip: tooltip, tag: tag, filters: filters, actions: actions, expanded: expanded, onToggle: onToggle, togglePosition: togglePosition, toggleIcon: toggleIcon })), _jsx(ItemsWrapper, { ...getCollapseProps(), horizontal: horizontal, hasTitle: hasTitle, children: children })] }));
}));
export const Section = Object.assign(SectionComponent, {
    Item: SubSection,
});
